const buttonStyle = {
  border: "none",
  borderRadius: "2px",
  cursor: "pointer",
  height: "31px",
  padding: "0px 30px",
  transition: "all 0.3s ease-in-out 0s",
};

export default buttonStyle;



// WEBPACK FOOTER //
// ./src/assets/EnergyCompany/jss/button.jsx